import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../../components/common-components/CommonStructured";
import { selectUser } from "../../components/auth/auth.selector";
import { fetchDashboardFeaturesdata } from "../../redux/dashboard-features/featuresSlice";
import "../../styles/dashboard-features/dashboard-features.css";
import SearchNButtons from "../../components/common-components/SearchNButtons";
import DashFeaturesForm from "../../components/feature-control/features/DashFeaturesForm";
import DashFeaturesList from "../../components/feature-control/features/DashFeaturesList";

const DashboardFeatures = () => {
  const userInfoData = useSelector(selectUser);
  const dispatch = useDispatch();

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    isActive: "",
    selectedSequence: "",
    selectedMenus: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    sequence_no: allFilters.selectedSequence?.value || "",
    menu_id: allFilters.selectedMenus?.value || "",
    status: allFilters.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getDashboardFeatures(filters) {
    dispatch(
      fetchDashboardFeaturesdata({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getDashboardFeatures(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      sequence_no: allFilters.selectedSequence?.value || "",
      menu_id: allFilters.selectedMenus?.value || "",
      status: allFilters.isActive?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedSequence,
    allFilters.selectedMenus,
    allFilters.isActive,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Dashboard Features">
      <Container className="bg-cloud-k px-50px" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Modal"
          ariaHideApp={false}
        >
          {modValues.cardName === "add" || modValues.cardName === "edit" ? (
            <DashFeaturesForm
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              isEdit={modValues.cardName === "edit"}
              closeModal={onCloseModal}
              callFunction={() => getDashboardFeatures(filters)}
            />
          ) : null}
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Dashboard Features"}
              createBtnTxt={"+ Add New Feature"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }))
              }
              isReload={() => getDashboardFeatures(filters)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <SearchNButtons
              pageName={"dash-features"}
              filters={allFilters}
              setFilters={setAllFilters}
              searchFilterApplied={searchFilterApplied}
              onClickSearch={onClickSearch}
              userInfoData={userInfoData}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <DashFeaturesList
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              callFunction={() => getDashboardFeatures(filters)}
              userInfoData={userInfoData}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default DashboardFeatures;
